import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

export const getGameRecord = async (gameId) => {
  const { data } = await req(ENDPOINTS.GAMES.GET_GAME(gameId))
  return data
}

export const getGameRecordWithMeta = async (gameId) => {
  const { data, meta } = await req(ENDPOINTS.GAMES.GET_GAME(gameId))
  return { data, meta }
}

export const getTeamRecordWithMeta = async (teamId) => {
  const { data, meta } = await req(ENDPOINTS.TEAMS.GET_TEAM(teamId))
  return { data, meta }
}

export const getGameRosterPlayers = async (gameId, rosterId) => {
  const { data } = await req(
    ENDPOINTS.GAMES.GET_GAME_ROSTER_PLAYERS(gameId, rosterId)
  )
  return data
}

export const updatePlayerAttendanceData = async (
  gameId,
  rosterId,
  playerId,
  body
) => {
  return await req(
    ENDPOINTS.GAMES.UPDATE_GAME_ROSTER_PLAYER_ATTENDANCE_DATA(
      gameId,
      rosterId,
      playerId
    ),
    { method: 'PUT', body: JSON.stringify(body) }
  )
}

export const updatePlayerAttendanceStatus = async (
  gameId,
  rosterId,
  playerId,
  attendanceStatus
) => {
  return await req(
    ENDPOINTS.GAMES.UPDATE_GAME_ROSTER_PLAYER_ATTENDANCE(
      gameId,
      rosterId,
      playerId
    ),
    {
      method: 'PUT',
      body: JSON.stringify({ attendance_status: attendanceStatus }),
    }
  )
}
